/* eslint-disable */
import React from 'react';
import type { FC } from 'react';
import { Grid } from '@mui/material';
import { Field, FormRenderProps } from 'react-final-form';
import { AUTOCOMPLETE_KEY_FIELD } from 'src/hooks/use-address-suggestions';
import DynamicInput, { addressFieldsToSuppressIfAutocomplete } from 'src/pages/application/components/dynamic-input';

import { useAddressStateFieldsStore } from '../store';

interface DynamicFieldI {
  containsBread: Boolean;
  formProps: FormRenderProps;
  objSchema: any;
  id: string;
  required_fields?: string[];
  // modified line
  registerFieldRef?: (fieldId: string, element: HTMLElement | null) => void;
  handleFieldBlur?: (fieldId: string) => void;
  section: string;
  // end modified
}

const DynamicField: FC<DynamicFieldI> = (props: DynamicFieldI) => {
  // modified line - Added registerFieldRef and handleFieldBlur
  const { formProps, containsBread, objSchema, id, required_fields, registerFieldRef, handleFieldBlur, section } =
    props;

  const { isAutocompleteEnabled } = useAddressStateFieldsStore();

  const isBasicFormFieldSection = section === 'basicFormFields';

  const needsExpandedCell =
    objSchema.name === AUTOCOMPLETE_KEY_FIELD && isAutocompleteEnabled && isBasicFormFieldSection;

  const isAddressFieldIgnored =
    addressFieldsToSuppressIfAutocomplete.includes(objSchema.name) && isBasicFormFieldSection;

  if (isAddressFieldIgnored && isAutocompleteEnabled) {
    return null;
  }

  return (
    <Grid item md={needsExpandedCell ? 9 : 3} xs={12} key={`dynamic_field_grid${id}`}>
      <Field name={id} key={`field_${id}`}>
        {(fieldProps) => (
          <div key={`dynamic_field_div${id}`}>
            <DynamicInput
              key={`dynamic_field_input_${id}`}
              section={section}
              containsBread={containsBread}
              formProps={formProps}
              objSchema={objSchema}
              fieldProps={fieldProps}
              keyValue={id}
              required_fields={required_fields}
              // modified line
              registerFieldRef={registerFieldRef}
              handleFieldBlur={handleFieldBlur}
              // end modified
            />
          </div>
        )}
      </Field>
    </Grid>
  );
};

export default DynamicField;
